import React, { useState, useEffect } from 'react';
import { getSchemes } from '../../../api/programmesApi';

const FA_KEYWORDS = ['financial', 'hardship', 'assistance', 'award', 'bursary', 'grant', 'welfare', 'relief'];

function isFAScheme(scheme) {
  const text = `${scheme.name || ''} ${scheme.description || ''} ${scheme.category || ''}`.toLowerCase();
  return FA_KEYWORDS.some(kw => text.includes(kw));
}

function FinancialAssistanceVolunteer({ orgId, volunteerId, volunteerName, activeTab }) {
  const [schemes, setSchemes]   = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    getSchemes(orgId)
      .then(data => setSchemes(data.filter(isFAScheme)))
      .catch(() => setSchemes([]))
      .finally(() => setLoading(false));
  }, [orgId]);

  return (
    <div className="bb-vol-tool">
      <div className="bb-vol-tool-header">
        <h2>Financial Assistance &amp; Awards</h2>
      </div>

      <div className="bb-vol-section">
        {/* Info box */}
        <div className="bb-alert bb-alert--info" style={{ marginBottom: 24 }}>
          <strong>Your Role as a Volunteer</strong>
          <p style={{ marginTop: 6, marginBottom: 0 }}>
            As a volunteer, you play a role in supporting members who may benefit from financial assistance programmes.
            If a member discloses a financial need to you, please encourage them to apply through their Member Portal,
            or contact a caseworker directly. Do not collect financial information from members yourself.
          </p>
        </div>

        {/* FA Schemes for members */}
        <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1F2937', marginBottom: 12 }}>
          Available Schemes for Members
        </h3>
        <p style={{ fontSize: 13, color: '#4B5563', marginBottom: 16 }}>
          The following financial assistance schemes are available for eligible members. Share this information
          with members who may benefit.
        </p>

        {loading ? (
          <div className="bb-loading-row">
            <div className="bb-loading-spinner" />
            <span>Loading schemes…</span>
          </div>
        ) : schemes.length === 0 ? (
          <div className="bb-empty-state">No financial assistance schemes found at this time.</div>
        ) : (
          schemes.map(s => (
            <div key={s.id} className="bb-card" style={{ marginBottom: 12 }}>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#1F2937', marginBottom: 4 }}>{s.name}</div>
              {s.category && (
                <span className="bb-badge" style={{ marginBottom: 6, display: 'inline-block' }}>{s.category}</span>
              )}
              {s.description && (
                <p style={{ fontSize: 13, color: '#4B5563', margin: 0 }}>{s.description}</p>
              )}
              {s.requirements && (
                <p style={{ fontSize: 12, color: '#6B7280', marginTop: 6 }}>
                  <strong>Eligibility:</strong> {s.requirements}
                </p>
              )}
            </div>
          ))
        )}

        {/* Caseworker referral card */}
        <div style={{
          marginTop: 28, padding: 20, background: '#F0FDF4', borderRadius: 10,
          border: '1px solid #BBF7D0'
        }}>
          <h3 style={{ fontSize: 14, fontWeight: 700, color: '#166534', marginBottom: 8 }}>
            Refer a Member to a Caseworker
          </h3>
          <p style={{ fontSize: 13, color: '#14532D', marginBottom: 12 }}>
            If a member urgently needs financial assistance or requires personalised support, encourage them to
            reach out to a caseworker directly or contact your organisation's welfare team.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <div style={{ background: '#fff', borderRadius: 8, padding: '12px 16px', border: '1px solid #D1FAE5', minWidth: 180 }}>
              <div style={{ fontSize: 11, color: '#6B7280', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Welfare Team</div>
              <div style={{ fontWeight: 600, fontSize: 13, color: '#1F2937' }}>WiCare Welfare Office</div>
              <div style={{ fontSize: 12, color: '#4B5563', marginTop: 2 }}>welfare@wicare.org.sg</div>
              <div style={{ fontSize: 12, color: '#4B5563' }}>+65 6XXX XXXX</div>
            </div>
            <div style={{ background: '#fff', borderRadius: 8, padding: '12px 16px', border: '1px solid #D1FAE5', minWidth: 180 }}>
              <div style={{ fontSize: 11, color: '#6B7280', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Caseworker Hotline</div>
              <div style={{ fontWeight: 600, fontSize: 13, color: '#1F2937' }}>Duty Caseworker</div>
              <div style={{ fontSize: 12, color: '#4B5563', marginTop: 2 }}>casework@wicare.org.sg</div>
              <div style={{ fontSize: 12, color: '#4B5563' }}>Available Mon–Fri, 9am–5pm</div>
            </div>
          </div>
          <p style={{ fontSize: 11, color: '#6B7280', marginTop: 12, marginBottom: 0 }}>
            Contact details above are managed by your organisation admin. If they appear outdated, please flag this to admin.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FinancialAssistanceVolunteer;
